import { apiClient, assertValidParam } from '@v2/lib';
import type {
  Pims,
  CreatePimsPayload,
  CreatePimsConfigPayload,
  UpdatePimsConfigPayload,
  UpdatePimsAppRelationPayload,
} from '@v2/types';

export const pimsService = {
  /** GET /api/Pims — list all PIMS */
  getPims: async (): Promise<Pims[]> => {
    const response = await apiClient().get<Pims[]>('Pims');
    return Array.isArray(response.data) ? response.data : [];
  },

  /** GET /api/Pims/{id} — get single PIMS with configurations */
  getSpecificPims: async (id: string): Promise<Pims> => {
    const safeId = assertValidParam(id, 'pimsId');
    const response = await apiClient().get<Pims>(`Pims/${safeId}`);
    return response.data;
  },

  /** POST /api/Pims/new — create a new PIMS */
  createPims: async (payload: CreatePimsPayload): Promise<string> => {
    const response = await apiClient().post<string>('Pims/new', payload);
    return response.data;
  },

  /** PATCH /api/Pims/{id}/connectivity — toggle supports connectivity */
  toggleConnectivity: async (id: string): Promise<void> => {
    const safeId = assertValidParam(id, 'pimsId');
    await apiClient().patch(`Pims/${safeId}/connectivity`);
  },

  /** POST /api/Pims/config — create a new configuration entry */
  createConfig: async (payload: CreatePimsConfigPayload): Promise<void> => {
    await apiClient().post('Pims/config', payload);
  },

  /** PATCH /api/Pims/config — update an existing configuration entry */
  updateConfig: async (payload: UpdatePimsConfigPayload): Promise<void> => {
    await apiClient().patch('Pims/config', payload);
  },

  /** PATCH /api/Pims/pimsAppRelation — update PIMS app association */
  updateAppRelation: async (payload: UpdatePimsAppRelationPayload): Promise<void> => {
    await apiClient().patch('Pims/pimsAppRelation', payload);
  },
};
